import CyberSecurity from '../../apis/cyberSecurityData';

// -----------------------------------------  Active Boards Actions ---------------------------------------------

export const setActiveBoard = (board) => (dispatch, getState) => {
    dispatch({
        type: 'SET_ACTIVE_BOARD',
        payload: board
    })

    let channel = '';
    if (board.channels && board.channels.length > 0) channel = board.channels[0];

    dispatch({
        type: 'SET_ACTIVE_CHANNEL',
        payload: channel
    })
}

// -----------------------------------------  Board Invitation Actions ---------------------------------------------

export const setInviteLink = (link) => {
    return {
        type: 'SET_INVIT_LINK',
        payload: link
    }
}

// -----------------------------------------  Active Channel Actions ---------------------------------------------

export const setActiveChannel = (channel) => {
    return {
        type: 'SET_ACTIVE_CHANNEL',
        payload: channel
    }
}

// -----------------------------------------  Active board filters Actions ---------------------------------------------

export const addFeedFilter = (key, value) => {
    return {
        type: 'ADD_FEED_FILTER',
        payload: { key, value }
    }
}

export const removeFeedFilter = (key) => {
    return {
        type: 'REMOVE_FEED_FILTER',
        payload: key
    }
}

export const resetFeedFilters = (key) => {
    return {
        type: 'RESET_FEED_FILTER',
    }
}

// -----------------------------------------  Active Boards Feed Actions ---------------------------------------------
export const fetchBoardFeed = (boardId, channel, filters, callback) => async (dispatch, getState) => {
    const response = await CyberSecurity.post(`/boardFeed/${boardId}`, { boardId, channel, filters }, {
        headers: {
            Authorization: `Bearer ${getState().accessToken}`
        }
    })

    const boardFeed = response.data;

    dispatch({
        type: 'FETCH_BOARD_FEED',
        payload: boardFeed
    });

    callback();
}

export const addNewFeed = (newItem) => {
    return {
        type: 'ADD_NEW_FEED',
        payload: newItem
    }
}

export const updateFeedItem = (updatedFeed) => {
    return {
        type: 'UPDATE_FEED_ITEM',
        payload: updatedFeed
    }
}

export const addFeedComment = (newComment) => {
    return {
        type: 'ADD_FEED_COMMENT',
        payload: newComment
    }
}

export const deleteFeedItem = (feedId) => {
    return {
        type: 'DELETE_FEED_ITEM',
        payload: feedId
    }
}

export const updateFeedComment = (comment) => {
    return {
        type: 'UPDATE_FEED_COMMENT',
        payload: comment
    }
}

export const deleteFeedComment = (comment) => {
    return {
        type: 'DELETE_FEED_COMMENT',
        payload: comment
    }
}

// -----------------------------------------  User Boards Actions ---------------------------------------------

//action to fetch all user boards, and if there is an active board in the redux state then it will make the first board in the response the active board (if the response array length > 0)
export const fetchUserBoards = () => async (dispatch, getState) => {
    const response = await CyberSecurity.get('/boards', {
        headers: {
            Authorization: `Bearer ${getState().accessToken}`
        }
    })

    const boards = response.data;

    dispatch({
        type: 'SET_USER_BOARDS',
        payload: boards
    });

    if (!getState().dashboard_Boards.activeBoard && boards.length > 0) {
        dispatch({ type: 'SET_ACTIVE_BOARD', payload: boards[0] })

        let channel = '';
        if (boards[0].channels && boards[0].channels.length > 0) channel = boards[0].channels[0];

        dispatch({
            type: 'SET_ACTIVE_CHANNEL',
            payload: channel
        })
    }
}

export const updateBoard = (board) => async (dispatch, getState) => {
    //if the board is the active board, will update the active board with the new one
    const activeBoard = getState().dashboard_Boards.activeBoard;
    if (activeBoard._id && activeBoard._id === board._id) {
        dispatch({
            type: 'SET_ACTIVE_BOARD',
            payload: board
        })

        let channel = '';
        if (board.channels && board.channels.length > 0) channel = board.channels[0];

        dispatch({
            type: 'SET_ACTIVE_CHANNEL',
            payload: channel
        })
    }

    //uselecting the board from user boards and updating it
    let userBoards = getState().dashboard_Boards.userBoards.map(el => el._id === board._id ? board : el);

    dispatch({
        type: 'SET_USER_BOARDS',
        payload: userBoards
    });

}

export const setUserBoards = (boards) => {
    return {
        type: 'SET_USER_BOARDS',
        payload: boards
    }
}

// -----------------------------------------  Action to Add to Bookmarks Channel (deos not change the store state) ------------------------------------------

//IMPORTANT
//this action assuming that the Bookmarks channel is in the first board (userBoards[0]) for the user, this logic needs to be redesigned when adding the team boards
export const addToReadLater = (itemId) => async (dispatch, getState) => {
    const accessToken = getState().accessToken;
    const userBoards = getState().dashboard_Boards.userBoards;

    if (userBoards && userBoards.length > 0) {
        const boardId = userBoards[0]._id;

        const record = {
            boardId,
            itemId,
            channel: 'Bookmarks',
            type: 'itemFeed',
        }

        const response = await CyberSecurity.post('/additemtoboard', record, {
            headers: {
                Authorization: 'Bearer ' + accessToken
            }
        })
    }

}